import { InstructorPageWrapper, withHTMLHeadSEO } from 'components/common';
import GradingProgress from 'components/features/grading-progress/GradingProgress';

const GradingProgressPage = () => <InstructorPageWrapper>{() => <GradingProgress />}</InstructorPageWrapper>;

export { GradingProgressPage as BaseGradingProgressPage };
export default withHTMLHeadSEO({ title: 'Student grading progress' })(GradingProgressPage);
